import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _get from 'lodash.get'
import { I18n } from 'react-redux-i18n'

import { FACEBOOK_TAGS } from 'constants/index'
import { marketingAct, composerAct } from 'redux/actions'
import { SelectWithLabel } from 'components/Form'
import './styles.scss'

const HUMAN_AGENT_FACEBOOK_TOTAL_TIME = 604800 // 7 days in seconds
const WITH_TAGS = ['facebook', 'instagram']

function SelectTemplateOutTime(props) {
  const { channel, provider, userId, updateTextEditor, token } = props
  const templateKey = provider === 'whatsapp' ? `${provider}_${channel}` : channel

  const templates = useSelector((store) => store.marketing.templates)
  const conversationComposer = useSelector((store) => _get(store, `conversations.${userId}.composer`, {}))
  const conversationUser = useSelector((store) => _get(store, `conversations.${userId}.user`, {}))
  const dispatch = useDispatch()

  const { tag, selectedTemplate } = conversationComposer
  const { lastMessageDate } = conversationUser
  const isFacebook = WITH_TAGS.includes(channel)
  const isHumanAgentDisabled = (Date.now() - new Date(lastMessageDate)) / 1000 > HUMAN_AGENT_FACEBOOK_TOTAL_TIME

  useEffect(() => {
    Promise.all([
      dispatch(marketingAct.getTemplateVariables()),
      dispatch(marketingAct.getChatTemplatesByChannel({
        channel, provider, token
      }))
    ])
  }, [dispatch, channel, provider, token])

  const onChangeTag = ({ value }) => {
    dispatch(composerAct.setRelatedTag(value))
  }

  const onChangeTemplate = ({ value }) => {
    const template = templates[templateKey].find((elem) => elem._id === value)
    if (!template) return

    const message = dispatch(composerAct.setMessageFromTemplate(value, template))
    updateTextEditor(message)
  }

  // Templates options
  const optionsTemplates = templates[templateKey].map((elem) => ({
    value: elem._id,
    label: elem.name,
    tag: elem.relatedTag
  }))

  // Translate facebook Options
  const facebookOptions = FACEBOOK_TAGS.tags.map((elem) => {
    elem.label = I18n.t(elem.label)
    elem.disabled = elem.value === 'HUMAN_AGENT' && isHumanAgentDisabled

    return elem
  })

  const tagValue = facebookOptions.find((elem) => elem.value === tag) || null
  const templateValue = optionsTemplates.find((elem) => elem.value === selectedTemplate) || null
  const classNotTemplate = classTemplateNotSelected({
    channel, isHumanAgentDisabled,
    templateSelected: !!templateValue,
    tagSelected: tagValue?.label
  })

  return (
    <div className='template-out-time'>
      {isFacebook ? (
        <SelectWithLabel
          id='facebook-relatedTag'
          name='relatedTag'
          classNameWrapper={`
            template-out-time__select
          `}
          placeholder={I18n.t('dashboard_label')}
          options={facebookOptions}
          value={tagValue}
          onChange={onChangeTag}
          isOptionDisabled={option => option.disabled}
        />
      ) : null}
      <SelectWithLabel
        id='related-template'
        name='relatedTemplate'
        classNameWrapper={`
          template-out-time__select
          ${channel === 'whatsapp' ? classNotTemplate : ''}
        `}
        placeholder={I18n.t('dashboard_template')}
        options={!isFacebook ? optionsTemplates : optionsTemplates.filter((elem) => elem.tag === tag)}
        value={templateValue}
        onChange={onChangeTemplate}
      />
    </div>
  )
}

export default SelectTemplateOutTime

function classTemplateNotSelected({ templateSelected, tagSelected, channel, isHumanAgentDisabled }) {
  if (templateSelected) return ''

  if (channel === 'whatsapp') return ''
  if (channel === 'facebook') {
    if (tagSelected === 'HUMAN_AGENT') return ''
    if (isHumanAgentDisabled) return ''
  }

  return ''
}